// src/components/Profile/EmptyAddressState.js
import React from 'react';

const EmptyAddressState = () => (
  <div className="text-center py-12 bg-gray-50 rounded-lg">
    {/* SVG icon */}
    <h3 className="mt-2 text-lg font-medium text-gray-900">No saved addresses</h3>
    <p className="mt-1 text-gray-500">Add your first shipping address to get started.</p>
  </div>
);

export default EmptyAddressState;